<template>
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="640" height="640" viewBox="0 0 640 640">
<path fill="#56D0E0" d="M320.032 249.6c-38.88 0-70.432 31.52-70.432 70.4s31.552 70.4 70.432 70.4c38.88 0 70.368-31.52 70.368-70.4s-31.488-70.4-70.368-70.4zM320.032 166.4c38.88 0 70.368-31.552 70.368-70.4s-31.488-70.4-70.368-70.4c-38.88 0-70.432 31.52-70.432 70.4s31.552 70.4 70.432 70.4zM320.032 473.6c-38.88 0-70.432 31.52-70.432 70.4s31.552 70.4 70.432 70.4c38.88 0 70.368-31.52 70.368-70.4s-31.488-70.4-70.368-70.4z"></path>
</svg>
</template>
